import(/* webpackMode: "eager" */ "/fetest-martina/app/global-error.tsx")